const updatesData = [
  { time: '10:42', tag: '娱乐圈', title: '某知名艺人被拍到深夜与神秘人士同行，疑似新恋情曝光引热议', hot: true },
  { time: '09:38', tag: '社会', title: '某城市高档小区物业纠纷升级，业主集体维权视频在社交平台疯传', hot: true },
  { time: '08:15', tag: '科技', title: '某头部互联网公司内部邮件泄露，新一轮组织架构调整即将公布', hot: false },
  { time: '07:22', tag: '财经', title: '某上市公司高管密集减持引监管关注，散户投资者需警惕风险', hot: true },
  { time: '23:50', tag: '娱乐圈', title: '某综艺节目录制现场突发意外，嘉宾受伤送医节目组发声明道歉', hot: false },
  { time: '22:30', tag: '社会', title: '某地食品安全抽检结果出炉，多家知名餐饮品牌被点名整改', hot: false },
  { time: '21:05', tag: '体育', title: '某体育明星转会传闻再起波澜，三支豪门俱乐部展开激烈争夺', hot: true },
  { time: '19:48', tag: '国际', title: '某国政要内部会议录音外泄，涉及多项敏感外交政策引发争议', hot: false },
];

export function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
            <i className="ri-flashlight-line text-background-50 text-base"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">最新爆料快讯</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 ml-11">实时追踪全网热点 · 分秒级同步更新</p>

        <div className="space-y-0">
          {updatesData.map((item, i) => (
            <div
              key={i}
              className={`flex items-start gap-3 md:gap-5 py-3.5 px-3 md:px-4 rounded-lg transition-colors hover:bg-background-100/70 group cursor-pointer ${
                i !== updatesData.length - 1 ? 'border-b border-background-200/60' : ''
              }`}
              style={{ animationDelay: `${i * 0.05}s` }}
            >
              <div className="flex-shrink-0 w-14 md:w-16 text-right">
                <span className="text-xs md:text-sm text-foreground-400 font-mono">{item.time}</span>
              </div>
              <div className="flex-shrink-0 mt-0.5">
                <span className={`inline-block px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${
                  item.hot
                    ? 'bg-primary-100 text-primary-700'
                    : 'bg-secondary-100 text-secondary-700'
                }`}>
                  {item.tag}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base text-foreground-800 group-hover:text-primary-600 transition-colors leading-relaxed">
                  {item.title}
                  {item.hot && (
                    <span className="inline-flex items-center ml-2 text-xs text-primary-500 font-semibold">
                      <i className="ri-fire-line mr-0.5"></i>热
                    </span>
                  )}
                </p>
              </div>
              <div className="flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity hidden md:block">
                <i className="ri-arrow-right-s-line text-foreground-400"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 rounded-lg bg-accent-500 flex items-center justify-center">
            <i className="ri-focus-2-line text-background-50 text-base"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">焦点爆料专题</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 ml-11">深度追踪热门事件 · 全景呈现爆料真相</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <div className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200/70 transition-all cursor-pointer">
            <div className="flex flex-col sm:flex-row">
              <div className="sm:w-[200px] md:w-[240px] flex-shrink-0 h-48 sm:h-auto relative overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Dramatic%20magazine%20cover%20style%20illustration%20showing%20entertainment%20news%20collage%20with%20camera%20flashes%2C%20spotlight%20effects%2C%20red%20carpet%20elements%2C%20warm%20theatrical%20lighting%20on%20dark%20background%2C%20editorial%20photography%20aesthetic%2C%20bold%20composition&width=480&height=360&seq=carousel-01&orientation=landscape"
                  alt="2026年娱乐圈上半年大瓜盘点"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  width="480"
                  height="360"
                />
              </div>
              <div className="flex-1 p-4 md:p-5 flex flex-col justify-center">
                <span className="text-xs text-primary-500 font-semibold mb-2">焦点专题 #1</span>
                <h3 className="font-heading text-base md:text-lg text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 leading-snug">
                  2026年娱乐圈上半年大瓜盘点：从隐婚到税务风波，哪些爆料最终实锤？
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">整理上半年最具话题度的十大娱乐爆料事件，追踪每一条线索的来龙去脉与最终真相，还原吃瓜群众最关注的完整时间线。</p>
              </div>
            </div>
          </div>

          <div className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200/70 transition-all cursor-pointer">
            <div className="flex flex-col sm:flex-row">
              <div className="sm:w-[200px] md:w-[240px] flex-shrink-0 h-48 sm:h-auto relative overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Futuristic%20tech%20newsroom%20concept%20with%20abstract%20circuit%20patterns%2C%20digital%20data%20streams%2C%20warm%20amber%20and%20charcoal%20color%20palette%2C%20minimalist%20tech%20illustration%20style%2C%20professional%20clean%20aesthetic%20with%20soft%20gradients&width=480&height=360&seq=carousel-02&orientation=landscape"
                  alt="科技巨头内幕深度起底"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  width="480"
                  height="360"
                />
              </div>
              <div className="flex-1 p-4 md:p-5 flex flex-col justify-center">
                <span className="text-xs text-primary-500 font-semibold mb-2">焦点专题 #2</span>
                <h3 className="font-heading text-base md:text-lg text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 leading-snug">
                  科技巨头内幕深度起底：从高管离职到战略转型，谁能笑到最后？
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">独家梳理近期科技行业重大人事变动与战略调整，解析背后资本博弈逻辑，展望下半年行业格局演变趋势。</p>
              </div>
            </div>
          </div>

          <div className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200/70 transition-all cursor-pointer">
            <div className="flex flex-col sm:flex-row">
              <div className="sm:w-[200px] md:w-[240px] flex-shrink-0 h-48 sm:h-auto relative overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20urban%20community%20and%20social%20topics%2C%20warm%20earthy%20tones%2C%20people%20silhouettes%20in%20cityscape%2C%20modern%20editorial%20style%2C%20clean%20composition%20with%20layered%20geometric%20elements%20on%20cream%20background&width=480&height=360&seq=carousel-03&orientation=landscape"
                  alt="社会热点追踪：2026年最受关注的民生议题"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  width="480"
                  height="360"
                />
              </div>
              <div className="flex-1 p-4 md:p-5 flex flex-col justify-center">
                <span className="text-xs text-primary-500 font-semibold mb-2">焦点专题 #3</span>
                <h3 className="font-heading text-base md:text-lg text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 leading-snug">
                  社会热点追踪：从维权事件到政策变化，2026年最受关注的民生议题
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">汇总近期引发广泛讨论的民生热点事件，结合政策走向与专家观点，为读者梳理事件全貌与潜在影响。</p>
              </div>
            </div>
          </div>

          <div className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200/70 transition-all cursor-pointer">
            <div className="flex flex-col sm:flex-row">
              <div className="sm:w-[200px] md:w-[240px] flex-shrink-0 h-48 sm:h-auto relative overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Financial%20market%20abstract%20concept%20with%20candlestick%20charts%2C%20flowing%20data%20ribbons%2C%20warm%20gold%20and%20deep%20charcoal%20color%20scheme%2C%20modern%20financial%20illustration%2C%20sophisticated%20editorial%20design%20with%20clean%20lines%20and%20textured%20background&width=480&height=360&seq=carousel-04&orientation=landscape"
                  alt="财经爆料解密：资本市场的暗流涌动"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  width="480"
                  height="360"
                />
              </div>
              <div className="flex-1 p-4 md:p-5 flex flex-col justify-center">
                <span className="text-xs text-primary-500 font-semibold mb-2">焦点专题 #4</span>
                <h3 className="font-heading text-base md:text-lg text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 leading-snug">
                  财经爆料解密：资本市场的暗流涌动，哪些信息被选择性忽略？
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">穿透财报数据与公告文字，揭示上市公司背后未被充分讨论的关键信息，助力投资者做出更明智的判断。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-information-line text-background-50 text-base"></i>
              </div>
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">关于爆料网</h2>
            </div>
            <p className="text-foreground-500 text-sm mb-6 ml-11">您的每日吃瓜爆料第一站</p>

            <div className="ml-11 space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                爆料网创立于对真相的执着追求，致力于为广大网友打造一个集
                <strong className="text-foreground-900">51爆料网</strong>、
                <strong className="text-foreground-900">91爆料网</strong>等热门爆料来源于一体的
                一站式资讯聚合平台。我们深知吃瓜群众的热情与期待，因此建立了7×24小时不间断的
                内容更新机制，确保您在任何时间打开爆料网，都能获取到最新的每日爆料内容。
              </p>
              <p>
                当您遇到<strong className="text-foreground-900">9-11爆料网打不开</strong>的情况时，
                爆料网为您提供稳定可靠的替代入口与最新网址，让精彩爆料永不中断。
                我们的编辑团队每日紧盯全网动态，从娱乐圈的大瓜到社会热点，从科技内幕到财经风云，
                为您呈现最具价值的爆料内容。
              </p>
              <p>
                爆料网汇聚了众多热心网友的投稿与线索，形成了独特的社区氛围——在这里，
                每一个吃瓜群众都可以成为爆料的发现者与传播者。我们严格审核每一条信息，
                在速度与真实性之间寻找最佳平衡，为您带来可信赖的独家内幕与最新地址更新。
              </p>
            </div>
          </div>

          <div className="flex-shrink-0 w-full max-w-[400px]">
            <div className="bg-background-100 rounded-2xl border border-background-200/70 p-6 md:p-8">
              <div className="grid grid-cols-2 gap-4">
                <div className="text-center">
                  <div className="text-3xl md:text-4xl font-bold text-primary-500 font-heading">138</div>
                  <div className="text-xs text-foreground-500 mt-1">今日更新爆料</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl md:text-4xl font-bold text-accent-500 font-heading">50+</div>
                  <div className="text-xs text-foreground-500 mt-1">覆盖爆料来源</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl md:text-4xl font-bold text-primary-500 font-heading">9.2万</div>
                  <div className="text-xs text-foreground-500 mt-1">累计爆料条目</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl md:text-4xl font-bold text-accent-500 font-heading">365</div>
                  <div className="text-xs text-foreground-500 mt-1">全年无休更新</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 rounded-lg bg-accent-500 flex items-center justify-center">
            <i className="ri-mail-send-line text-background-50 text-base"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">联系我们</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 ml-11">有料就来爆 · 你的线索可能成为明日头条</p>

        <div className="ml-11 bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-message-3-line text-primary-600 text-xl"></i>
              </div>
              <div>
                <h3 className="font-semibold text-foreground-900 text-base mb-1">投稿爆料</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  将您掌握的独家线索发送给我们，编辑团队审核通过后将第一时间发布并标注来源。
                </p>
                <a href="#hero" className="inline-block mt-2 text-sm text-primary-600 font-medium hover:text-primary-700 whitespace-nowrap">
                  立即投稿 <i className="ri-arrow-right-line ml-1"></i>
                </a>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-hand-heart-line text-accent-600 text-xl"></i>
              </div>
              <div>
                <h3 className="font-semibold text-foreground-900 text-base mb-1">商务合作</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  寻求广告投放、内容合作或品牌联合推广，我们提供多样化的合作方案。
                </p>
                <a href="#hero" className="inline-block mt-2 text-sm text-accent-600 font-medium hover:text-accent-700 whitespace-nowrap">
                  了解合作 <i className="ri-arrow-right-line ml-1"></i>
                </a>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-feedback-line text-secondary-700 text-xl"></i>
              </div>
              <div>
                <h3 className="font-semibold text-foreground-900 text-base mb-1">问题反馈</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  如遇页面访问异常或9-11爆料网打不开等问题，请及时联系我们获取最新可用地址。
                </p>
                <a href="#faq" className="inline-block mt-2 text-sm text-secondary-700 font-medium hover:text-secondary-800 whitespace-nowrap">
                  查看帮助 <i className="ri-arrow-right-line ml-1"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const featuresData = [
  {
    icon: 'ri-speed-up-line',
    title: '极速同步更新',
    desc: '7×24小时不间断监控全网爆料动态，分秒级同步至本站，确保您永远快人一步获取最新吃瓜爆料内容与最新网址。',
  },
  {
    icon: 'ri-shield-flash-line',
    title: '稳定访问保障',
    desc: '针对51爆料网、91爆料网及9-11爆料网打不开等情况提供多重备用入口，无论何时何地都能顺利访问每日爆料内容。',
  },
  {
    icon: 'ri-filter-3-line',
    title: '智能内容筛选',
    desc: '采用智能算法对海量爆料内容进行分类整理，帮您快速定位娱乐圈、社会热点、科技财经等感兴趣的爆料专区。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '社区互动生态',
    desc: '汇聚千万吃瓜群众共同参与，你不仅能在爆料网浏览每日最新爆料，更能分享独家线索成为内容贡献者。',
  },
];

export function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
            <i className="ri-star-line text-background-50 text-base"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">平台优势</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 ml-11">为什么千万吃瓜群众选择爆料网</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuresData.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl border border-background-200/70 p-5 md:p-6 hover:border-primary-200/70 transition-all group cursor-pointer"
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-primary-600 text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-primary-500">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-1 text-center lg:text-left">
            <div className="flex items-center gap-3 mb-2 justify-center lg:justify-start">
              <div className="w-8 h-8 rounded-lg bg-background-50/20 flex items-center justify-center">
                <i className="ri-smartphone-line text-background-50 text-base"></i>
              </div>
              <h2 className="font-heading text-2xl md:text-3xl text-background-50">爆料网App</h2>
            </div>
            <p className="text-background-50/80 text-sm mb-2 ml-11">随时随地 · 吃瓜不停</p>
            <p className="text-background-50/90 text-base leading-relaxed mb-6 ml-11">
              下载爆料网App，无论51爆料网、91爆料网是否打不开，手机端一键直达每日吃瓜爆料最新地址。
              推送通知让您不错过任何一条热门爆料，离线缓存功能助您随时随地畅享爆料内容。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 ml-11">
              <button className="w-full sm:w-auto px-8 py-3.5 bg-background-50 text-primary-600 font-semibold text-base rounded-lg hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer">
                <i className="ri-apple-line mr-2"></i>App Store 下载
              </button>
              <button className="w-full sm:w-auto px-8 py-3.5 bg-primary-600 text-background-50 font-semibold text-base rounded-lg hover:bg-primary-700 transition-all border border-background-50/20 whitespace-nowrap cursor-pointer">
                <i className="ri-android-line mr-2"></i>Android 下载
              </button>
            </div>
          </div>

          <div className="flex-shrink-0">
            <div className="w-56 md:w-64 rounded-3xl border-4 border-background-50/30 overflow-hidden bg-background-50 p-2">
              <img
                src="https://readdy.ai/api/search-image?query=Mobile%20app%20screen%20mockup%20showing%20news%20feed%20with%20breaking%20news%20cards%20in%20warm%20red%20and%20cream%20color%20scheme%2C%20clean%20modern%20UI%20design%2C%20Chinese%20text%20interface%2C%20minimalist%20layout%20with%20card%20based%20design%2C%20soft%20lighting%20on%20phone%20screen&width=600&height=1200&seq=app-mockup-2026&orientation=portrait"
                alt="爆料网App移动端界面展示"
                className="w-full h-auto rounded-2xl"
                width="600"
                height="1200"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}